module.exports = "https://health.dajiuxing.com.cn/img/assets/mine/8ec41e3ab32a6d5fd8b512b00949249c42d0e6af2d589-8nj1zo_fw1200@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fmine%2F8ec41e3ab32a6d5fd8b512b00949249c42d0e6af2d589-8nj1zo_fw1200%402x.png
// module id = NPC3
// module chunks = 93